import { Controller } from "@hotwired/stimulus"

/**
 * Dismisses a feature-intro card and persists the dismissal for the current user.
 *
 * Usage:
 *   <div data-controller="feature-intro"
 *        data-feature-intro-url-value="/feature_intros/policies">
 *     <button data-action="feature-intro#dismiss">…</button>
 *   </div>
 */
export default class extends Controller {
  static values = { url: String }

  dismiss() {
    // Fire the persistence request before detaching the element, then hide it
    // immediately for a responsive feel.
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": this.csrfToken
      },
      credentials: "same-origin"
    }).catch((error) => {
      console.error("Failed to persist feature-intro dismissal:", error)
    })

    this.element.remove()
  }

  get csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.getAttribute("content") : ""
  }
}
